import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initDocumentCards() {
  Alpine.data(
    'documentCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.SwiperDocs');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl: HTMLElement) {
        this.swiper = new Swiper(domEl, {
          modules: [Navigation],
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .SwiperDocs__next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .SwiperDocs__prev`,
          },
          slidesPerView: 1,
          spaceBetween: 20,
          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      },
    }),
  );
}
